import styled from "styled-components";

import TableInput from "components/datatable/Controls/TableInput";

const TableInputDate = styled(TableInput)`
  height: 2.3em;
`;

export default TableInputDate;
